var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSorter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 616.1 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sorter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M614.13,177.5a24,24,0,0,0-4.6-26l-136-144a23.93,23.93,0,0,0-34.8,0l-136,144a24,24,0,0,0,17.4,40.5h88V480a32,32,0,0,0,32,32h32a32,32,0,0,0,32-32V192h88A23.93,23.93,0,0,0,614.13,177.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318,334.5a24,24,0,0,1-4.6,26l-136,144a23.93,23.93,0,0,1-34.8,0l-136-144A24,24,0,0,1,24,320h88V32A32,32,0,0,1,144,0h32a32,32,0,0,1,32,32V320h88A23.93,23.93,0,0,1,318,334.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorter);
export default __webpack_public_path__ + "static/media/sorter.d27164cf2f6e13002de98d1ea1cf8cfa.svg";
export { ForwardRef as ReactComponent };